<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <div class="title">Recap Omset</div>
        <DataTable
          :value="omsetRecap"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="20"
          data-key="doc_number"
          :rowHover="true"
          :scrollable="true"
          scrollDirection="horizontal"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col-3">
                <Calendar
                  v-model="start_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="Start Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col-3">
                <Calendar
                  v-model="end_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="End Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col-3">
                <Button
                  label="Cari"
                  class="p-button-info"
                  @click="getRecapOmset()"
                  v-shortkey.push="['enter']"
                  @shortkey="getRecapOmset()"
                />
              </div>
            </div>
            <!-- table ke samping -->
            <table class="table table-responsive" style="font-size: 16px">
              <tbody>
                <tr>
                  <td>
                    <h5>Omset</h5>
                  </td>
                  <td>
                    <h5>Diskon Item</h5>
                  </td>
                  <td>
                    <h5>Diskon Kasir</h5>
                  </td>
                  <td>
                    <h5>Infaq</h5>
                  </td>
                  <td>
                    <h5>Pembulatan</h5>
                  </td>
                  <td>
                    <h5>Voucher</h5>
                  </td>
                  <td>
                    <h5>Total Item</h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>{{ total_omset | currency }}</h5>
                  </td>
                  <td>
                    <h5>{{ total_disc_item | currency }}</h5>
                  </td>
                  <td>
                    <h5>{{ total_disc_cashier | currency }}</h5>
                  </td>
                  <td>
                    <h5>{{ total_infaq | currency }}</h5>
                  </td>
                  <td>
                    <h5>{{ total_round_up | currency }}</h5>
                  </td>
                  <td>
                    <h5>{{ total_voucher | currency }}</h5>
                  </td>
                  <td>
                    <h5>{{ total_item | number }}</h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading>Mengambil data recap omset. Mohon tunggu</template>
          <Column
            header="Audit Date"
            headerStyle="text-align: center; width: 15rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.audit_date }}
              </div>
            </template>
          </Column>
          <Column header="Omset" headerStyle="text-align: center; width: 15rem">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.omset | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Diskon Item"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.disc_item | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Diskon Kasir"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.disc_cashier | currency }}
              </div>
            </template>
          </Column>
          <Column header="Infaq" headerStyle="text-align: center; width: 12rem">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.infaq | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Pembulatan"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.round_up | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Voucher"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.voucher | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Total Item"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_item | number }}
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      loading: true,
      omsetRecap: null,
      start_date: null,
      end_date: null,
      confirmDialog: false,
      total_omset: null,
      total_disc_item: null,
      total_disc_cashier: null,
      total_infaq: null,
      total_round_up: null,
      total_voucher: null,
      total_item: null
    }
  },
  mounted() {
    this.getRecapOmset()
    this.getAuthUser()
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
    },
    getRecapOmset() {
      let start_date = this.start_date
        ? moment(this.start_date).format('YYYY-MM-DD')
        : ''

      let end_date = this.end_date
        ? moment(this.end_date).format('YYYY-MM-DD')
        : ''

      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/omsetrecap?start_date=${start_date}&end_date=${end_date}`
        )
        .then(response => {
          if (response.status === 200) {
            this.omsetRecap = response.data.data.omset_recap
            this.clearOmset()
            this.getAllCalculate()
          }
        })
    },

    getAllCalculate() {
      this.omsetRecap.forEach(item => {
        this.total_omset += parseInt(item.omset)
        this.total_disc_item += parseInt(item.disc_item)
        this.total_disc_cashier += parseInt(item.disc_cashier)
        this.total_infaq += parseInt(item.infaq)
        this.total_round_up += parseInt(item.round_up)
        this.total_voucher += parseInt(item.voucher)
        this.total_item += parseInt(item.total_item)
      })
    },

    clearOmset() {
      this.total_omset = 0
      this.total_disc_item = 0
      this.total_disc_cashier = 0
      this.total_infaq = 0
      this.total_round_up = 0
      this.total_voucher = 0
      this.total_item = 0
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
